module.exports = __webpack_public_path__ + "static/img/engb1.c08a669.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/engb1.png
// module id = 6QCx
// module chunks = 0